import React from "react";
import classes from "./Consent.css";
const Consent = (props) => {
  const onCustomCheckboxPress = (event) => {
    if (event.which === 32 || event.keyCode === 32) {
      props.handleConsentChange({
        target: { name: props.consent.name, checked: !props.consent.value },
      });
      event.preventDefault();
    }
  };
  return (
    <div className={classes.CheckboxContainer}>
      <h3 className={classes.ConsentTitle}>{props.consent.title}</h3>
      <input
        type="checkbox"
        checked={props.consent.value}
        name={props.consent.name}
        id={`${props.consent.name}_${props.type}`}
        className={classes.Checkbox}
        tabIndex="-1"
        onChange={props.handleConsentChange}
      />
      <label
        htmlFor={`${props.consent.name}_${props.type}`}
        className={classes.CheckboxLabel}
      >
        <span
          className={classes.CustomCheckbox}
          onKeyPress={onCustomCheckboxPress}
          tabIndex="0"
        ></span>
        <span className={classes.consentText}>{props.consent.label}</span>
      </label>
    </div>
  );
};
export default Consent;
